import * as React from 'react';
import { Box, TextButton, Text, Button } from '@wix/design-system';
import { RefreshSmall } from '@wix/wix-ui-icons-common';
import s from './SuggestMultiplePlanNames.scss';
import { getPriceText } from '../utils';
export const SuggestMultiplePlanNames = _ref => {
  let {
    data: {
      plans
    },
    context: {
      send,
      onWidgetAction
    }
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2,
    paddingTop: "SP1",
    paddingBottom: "SP1",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, "Suggested plan names"), /*#__PURE__*/React.createElement(Box, {
    className: s.card,
    direction: "vertical"
  }, plans.map((plan, index) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, index > 0 && /*#__PURE__*/React.createElement(Box, {
      marginLeft: "SP2",
      marginRight: "SP2",
      className: s.divider
    }), /*#__PURE__*/React.createElement(Box, {
      padding: "SP2",
      direction: "vertical"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "normal"
    }, plan.name), /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      light: true,
      secondary: true
    }, getPriceText(plan))));
  })), /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    align: "space-between",
    paddingRight: "SP1",
    paddingTop: "SP2"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      send("I'll use these plan names!");
      onWidgetAction(PRICING_PLANS_SUGGEST_MULTIPLE_PLAN_NAMES, {
        action: 'select',
        value: plans
      });
    },
    size: "tiny",
    className: s.button
  }, "Use names"), /*#__PURE__*/React.createElement(TextButton, {
    onClick: () => {
      send('Regenerate please.');
      onWidgetAction(PRICING_PLANS_SUGGEST_MULTIPLE_PLAN_NAMES, {
        action: 'regenerate'
      });
    },
    prefixIcon: /*#__PURE__*/React.createElement(RefreshSmall, null),
    size: "tiny",
    className: s.icon
  }, "Regenerate")));
};
export const PRICING_PLANS_SUGGEST_MULTIPLE_PLAN_NAMES = 'PRICING_PLANS_SUGGEST_MULTIPLE_PLAN_NAMES';
//# sourceMappingURL=SuggestMultiplePlanNames.js.map